export const OrgStatusOptions = {
  ACTIVE: 'ACTIVE',
  SOURCE_COUNT_CAPPED: 'SOURCE_COUNT_CAPPED',
  SOURCE_DATA_CAPPED: 'SOURCE_DATA_CAPPED',
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
};

export const GAPILoadStatusTypes = {
  GAPI_LOAD_STATUS_INIT: 'init',
  GAPI_LOAD_STATUS_ERROR: 'error',
  GAPI_LOAD_STATUS_READY: 'ready',
};

export type GAPILoadStatus = 'init' | 'error' | 'ready';
